/// <reference path="index.d.ts" />

import * as React from 'react'
import { StoreProvider } from './store'

import ErrorBoundary from './common/error-boundary';

import BreadcrumbLayout from './components/breadcrumb';
import MainImage from './components/main-image';
import ProductTitle from './components/product-title';
import ProductCertification from './components/product-certification';
import ProductDiscuss from './components/product-discuss';
import ProductPrice from './components/product-price';
import ProductSku from './components/product-sku';
import BuyerSample from './components/buy-sample';
import LeadTime from './components/leadtime';
import Customization from './components/customization';
import ProductShip from './components/product-ship';
import MainActions from './components/main-actions';
import CompanyCard from './components/company-card';
import ProductService from './components/product-service';
import BuyerBenefits from './components/buyer-benefits';
import ProductReview from './components/product-review';
import ProductPromotion from './components/product-promotion';
import ProductCountDown from './components/product-countdown';
import ProductInventory from './components/product-inventory';
import YouMayLike from './components/you-may-like';

import ProductTa from './components/product-ta';
import ProductGlp from './components/product-glp';

import { getModuleData } from './common/data'

const {useEffect, useRef} = React;

export default function Layout(props: detailTypes) {
  const { globalData } = props;
  const rightActions = useRef(null);
  const mainActions = useRef(null);

  // 只是客户端执行
  // 滚动窗口卡片固定
  if (!window.__getComponentInNode){
    const intersectionObserver = new IntersectionObserver(entries => {
      const {current} = rightActions;
      if (current) {
        if (entries[0].intersectionRatio <= 0) {
          current.className = 'layout-right fixed';
        }else{
          current.className = 'layout-right';
        }
      }else{
        intersectionObserver.disconnect();
      }
    });

    useEffect(() => {
      intersectionObserver.observe(mainActions.current);
      return () => {
        intersectionObserver.disconnect();
      }
    }, [])
    
  }

  return (
    <StoreProvider>
      <div className="layout-content" ref={mainActions}>
        <div className="layout-screen">
          <BreadcrumbLayout {...getModuleData('module_breadcrumb', props)} />
          <div className="screen-body">
            <div className="screen-layout">
              <div className="layout-left">
                <ErrorBoundary module="module_main_image"><MainImage {...getModuleData('module_main_image', props) as any} /></ErrorBoundary>
                <div id="user-actions"></div>
                <div className="main-screen">
                  <ErrorBoundary module="module_title"><ProductTitle {...getModuleData('module_title', props)} /></ErrorBoundary>
                  <ErrorBoundary module="module_title"><ProductCertification {...getModuleData('module_title', props) as any} /></ErrorBoundary>
                  <ProductReview tabs={globalData.global.tabs} />
                  <ErrorBoundary module="module_glp"><ProductGlp {...getModuleData('module_glp', props) as any} /></ErrorBoundary>
                  <ErrorBoundary module="module_detail_discuss"><ProductDiscuss {...getModuleData('module_detail_discuss', props) as any} /></ErrorBoundary>
                  <ErrorBoundary module="module_price"><ProductPrice {...getModuleData('module_price', props) as any} /></ErrorBoundary>
                  <ErrorBoundary module="module_promotion"><ProductPromotion {...getModuleData('module_promotion', props) as any} /></ErrorBoundary>
                  {/* 用户权益 */}
                  <div id="product-promotion"></div>
                  <ErrorBoundary module="module_benefits"><BuyerBenefits {...getModuleData('module_benefits', props) as any} /></ErrorBoundary>
                  <ErrorBoundary module="module_activity_count_down"><ProductCountDown {...getModuleData('module_activity_count_down', props) as any}/></ErrorBoundary>
                  <div className="main-attr">
                  <ErrorBoundary module="module_sku"><ProductSku {...getModuleData('module_sku', props) as any} /></ErrorBoundary>
                  <ErrorBoundary module="module_buyer_sample"><BuyerSample {...getModuleData('module_buyer_sample', props) as any} /></ErrorBoundary>
                  <ErrorBoundary module="module_inventory_dispatch"><ProductInventory {...getModuleData('module_inventory_dispatch', props) as any} /></ErrorBoundary>
                  <ErrorBoundary module="module_leadtime_table"><LeadTime {...getModuleData('module_leadtime_table', props) as any} /></ErrorBoundary>
                  <ErrorBoundary module="module_customization"><Customization {...getModuleData('module_customization', props) as any} /></ErrorBoundary>
                  <ErrorBoundary module="module_market_action"><ProductShip {...getModuleData('module_market_action', props) as any} /></ErrorBoundary>
                  <ErrorBoundary module="module_after_service"><ProductService {...getModuleData('module_after_service', props) as any} /></ErrorBoundary>
                  <ErrorBoundary module="module_ta"><ProductTa {...getModuleData('module_ta', props) as any} /></ErrorBoundary>
                  </div>
                </div>
              </div>
              <div className="layout-right" ref={rightActions}>
                <div className='layout-fixed'>
                  <ErrorBoundary module="module_actions"><MainActions {...getModuleData('module_actions', props) as any} /></ErrorBoundary>
                  <ErrorBoundary module="module_companycard"><CompanyCard  {...getModuleData('module_companycard', props) as any} /></ErrorBoundary>
                </div>
              </div>
            </div>
            <YouMayLike {...getModuleData('module_recommandproducts_you_may_like', props) as any}/>
          </div>
        </div>
      </div>
      <div id="layout-other"></div>
    </StoreProvider>
  )
}
